import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // StrictMode 임시 비활성화 - 개발 환경에서만 영향
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);